export enum DoctorStatus {
  NOT_ACCEPTED = 'NOT_ACCEPTED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DECLINED = 'DECLINED',
  INCOMPLETE_REGISTRATION = 'INCOMPLETE_REGISTRATION'
}